<template>
  <div class="user-table-page">
    <h3>
      <strong>User</strong>
    </h3>
    <a-table
      :data-source="users"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="{
        onChange: handlePaginationChange,
      }"
      :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      class="user-table"
    >
      <!-- Slot untuk kolom 'No' -->
      <template #bodyCell="{ column, index }">
        <template v-if="column.key === 'no'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import { UserManagementAPI } from '@/services/axios/istry/pathwayService'

export default {
  name: 'UserTablePage',
  data() {
    return {
      users: [],
      columns: [
        {
          title: 'No',
          key: 'no',
          width: 60,
          slots: { customRender: 'bodyCell' },
        },
        {
          title: 'Name',
          dataIndex: 'fullName',
          key: 'fullName',
          sorter: (a, b) => a.fullName.localeCompare(b.fullName),
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
          title: 'Job Title',
          dataIndex: 'jobTitle',
          key: 'jobTitle',
          sorter: (a, b) => a.jobTitle.localeCompare(b.jobTitle),
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
      },
    }
  },
  async mounted() {
    try {
      const data = await UserManagementAPI.getAllUsers('user')
      this.users = Array.isArray(data?.data) ? data.data : []
    } catch (error) {
      this.users = []
    }
  },
  methods: {
    handlePaginationChange(page, pageSize) {
      // Update pagination state
      this.pagination.current = page
      if (pageSize) {
        this.pagination.pageSize = pageSize
      }

      // Scroll to top when pagination changes
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.user-table-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user-table {
  border-radius: 12px;
  overflow: hidden;
  color: #395b86;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #e3f0fa;
}

:deep(.ant-table-tbody > tr > td:nth-child(even)) {
  background-color: #f7fbfe; /* slightly darker blue */
}

:deep(.ant-table-thead > tr > th:nth-child(odd)) {
  background-color: #f2faff;
}

:deep(.ant-table-thead > tr > th:nth-child(even)) {
  background-color: #e6f4fc;
}
</style>
